import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useAddGroupManagersToGroups() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({ userUuids, groupUuids }: { userUuids: string[]; groupUuids: string[] }) => {
      await api.post('group/assign-group-managers-to-groups', {
        members: userUuids,
        groups: groupUuids,
      })

      await Promise.all([invalidate.users(), invalidate.groups()])
    },
  })
}
